export const END_OF_MESSAGE_DELAY_TIME = 1000;